module.exports = __webpack_public_path__ + "141eb0127a53fd3b1397676cf0c63bdd.fbx";